<script>

  import Vue from 'vue'
  import {mapActions, mapGetters} from 'vuex';
  import moduleUtils from 'src/app/module/ModuleUtils';

  export default{
    props: ["attr", "instance", "formIdentifier"],
    data() {
      return {
        currentView: '',
        params: {
          instance: null
        }
      }
    },
    components: {
    },
    methods: {
      ...mapActions([
      'showLoader',
      'hideLoader'
    ]),
    callBusinessRule: function(instance, businessRuleId) {

      this.showLoader();

      moduleUtils.callBusinessRule(this.formIdentifier, instance, businessRuleId)
        .then(response => {
          this.hideLoader();

          _.forOwn(response.body.instance, (value, key) => {
            this.$set(instance, key, value);
          });

          if(response.body.notificationError != null) {
            this.$eventBus.$emit('notification-error', response.body.notificationError);
          }

          if(response.body.notificationSuccess != null) {
            this.$eventBus.$emit('notification-success', response.body.notificationSuccess);
          }
        })
      }
    },
    computed: {
    },
    mounted: function() {
      if (this.attr.template) {

        this.params.urlAttachment = moduleUtils.resolveFormDesc(this.formIdentifier) + "/attachment";
        // this.params.parentId = this.parentId;
        // this.params.moment = require('moment');
        // this.params.formIdentifier = this.formIdentifier;
        this.params.instance = this.instance;
        this.params.userLanguage = this.$i18n.locale;

        let vueJson = eval('(' + this.attr.script + ')');
        vueJson.template = this.attr.template;

        let customDynamicComponentName = "customDynamicComponent_" + Math.floor((Math.random() * 1000) + 1);

        Vue.component(customDynamicComponentName, vueJson);
        this.currentView = customDynamicComponentName;
      }
    }
  }

</script>

<template>
  <div>
    <component
      :is="currentView"
      :params="params"
      @callBusinessRule="callBusinessRule"
    >
    </component>
  </div>
</template>



// WEBPACK FOOTER //
// SgsRenderCustomComponent.vue?c5f14788